import React from 'react';

export default class RpTotalItemCountInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: props.initialCount || "",
      max_item_analysis : props.max_item_analysis || null
    };
  }

  handleChange = (e) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, "");
    this.setState({ count: inputValue }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.count);
      }
    });
  }

  handleBlur = (e) => {
    if ((e.target.value == null || e.target.value === "") && this.props.onChange) {
      this.setState({ count: "0" }, () => {
        this.props.onChange("0");
      });
    }
  }

  render() {
    return (
      <>
        {
          this.state.max_item_analysis != null && this.state.max_item_analysis == 3
          ? <span>
            알고리즘 상위 배분으로,
            </span>
          : this.state.max_item_analysis != null && this.state.max_item_analysis == 2
            ? <span>
              알고리즘별 균등 배분으로,
              </span>
            : ""
        }
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {
            this.state.max_item_analysis != null && this.state.max_item_analysis == 1
            ?
              <span>
              자동 합산으로, 총 <b>{this.state.count}개</b>의 상품을 진열합니다.
              </span>
            :
              <>
                <span>총</span>
                <input
                  type="text"
                  className="text_14 list_input_disabled"
                  maxLength="3"
                  value={this.state.count}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  autoComplete="off"
                  tabIndex={-1}
                  style={{ width: '80px', height: '38px', textAlign: 'center' }}
                />
                <span>개의 상품을 진열합니다.</span>
              </>
          }
        </div>
        {
            this.state.max_item_analysis != null && this.state.max_item_analysis == 1
            &&
            <div className="flexBox" style={{
              color: "gray",
              fontSize: "13px",
              alignItems: "center",
              gap: "4px"
            }}>
            <span
              style = {{
                display: "flex",
                alignItems: "center",
              }}
            ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="gray" class="bi bi-info-circle-fill" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg></span> 
            <span>자동 합산으로 설정된 경우, 복제 과정에서는 개수를 바꿀 수 없으며, 복제 후 변경해주세요.</span>
            </div>
        }
      </>
    );
  }
}
